<!-- A standard "video" icon (a screen with a play triangle) for the links at the end of a
     program item that open a video. Distinct from the left-hand camera (VideoIcon), which shows
     whether the item is online. In the surrounding text colour (currentColor): inside a
     link it's the link blue, with its hover colour. With a label it's an image with that name;
     without one (the program legend, beside its own text) it's decorative, hidden from assistive
     technology. -->
<template>
  <svg
    class="videoPlayIcon"
    viewBox="0 0 24 24"
    :role="label ? 'img' : undefined"
    :aria-label="label || undefined"
    :aria-hidden="label ? undefined : 'true'">
    <title v-if="label">{{ label }}</title>
    <path
      fill-rule="evenodd"
      :d="SCREEN_WITH_PLAY" />
  </svg>
</template>

<script setup>
defineProps({label: {type: String, default: ""}});

// a 20 × 16 rounded screen, with a 7.5 × 9 play triangle cut out of it (▶ EDIT HERE: triangle)
const SCREEN = "M5 4h14a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3Z";
const PLAY = "M9.5 7.5v9l7.5-4.5Z";
const SCREEN_WITH_PLAY = `${SCREEN}${PLAY}`;
</script>

<style scoped>
.videoPlayIcon {
  display: inline-block;
  width: 1.05em; /* ▶ EDIT HERE: icon size, relative to the program text */
  height: 1.05em;
  vertical-align: -0.15em; /* sits on the text's baseline */
  fill: currentColor;
}
</style>
